const authorizationConstants = {
    AUTHORIZATION_NAME_ALL : 'AUTHORIZATION_ALL',

    AUTHORIZATION_NAME_VIEW : 'AUTHORIZATION_VIEW',

    AUTHORIZATION_NAME_UPDATE : 'AUTHORIZATION_UPDATE',

    AUTHORIZATION_NAME_DELETE : 'AUTHORIZATION_DELETE',

    AUTHORIZATION_NAME_PERMISSION : 'AUTHORIZATION_PERMISSION',

    AUTHORIZATION_CHANGE_PASSWORD : 'AUTHORIZATION_CHANGE_PASSWORD',

    SAVE_LOAD_SYSTEM_FILES : 'AUTHORIZATION_SAVE_LOAD_SYSTEM_FILES',

    LIVE_CHAT : 'AUTHORIZATION_LIVE_CHAT',

    CLEAR_ALL_CHAT_MESSAGES : 'AUTHORIZATION_CLEAR_ALL_CHAT_MESSAGES',

    AUTHORIZATION_CHECK_LOA_CHECKLIST_ITEM : 'AUTHORIZATION_CHECK_LOA_CHECKLIST_ITEM',

    VIEW_CONFIG_FORMS : 'AUTHORIZATION_CONFIGURATOR_FORMS_VIEW',

    SAVE_AS_NEW_CONFIG_FORMS : 'AUTHORIZATION_CONFIGURATOR_FORMS_SAVE_AS_NEW',

    VIEW_CONFIG_DATASETS : 'AUTHORIZATION_CONFIGURATOR_DATASETS_VIEW',

    MANAGE_DATASETS : 'AUTHORIZATION_MANAGE_DATASETS',

    VIEW_CONFIG_IMPORT_DATA : 'AUTHORIZATION_CONFIGURATOR_IMPORT_DATA_VIEW',

    MODIFY_CONFIG_IMPORT_DATA : 'AUTHORIZATION_CONFIGURATOR_IMPORT_DATA_MODIFY',

    VIEW_CONFIG_CLASSCODES : 'AUTHORIZATION_CONFIGURATOR_CLASSCODES_VIEW',

    MODIFY_CONFIG_CLASSCODES : 'AUTHORIZATION_CONFIGURATOR_CLASSCODES_MODIFY',

    VIEW_CONFIG_AMBEST_CARRIERS : 'AUTHORIZATION_CONFIGURATOR_AMBEST_CARRIERS_VIEW',

    MODIFY_CONFIG_AMBEST_CARRIERS : 'AUTHORIZATION_CONFIGURATOR_AMBEST_CARRIERS_MODIFY',

    VIEW_CONFIG_RULES : 'AUTHORIZATION_CONFIGURATOR_RULES_VIEW',

    MODIFY_CONFIG_RULES : 'AUTHORIZATION_CONFIGURATOR_RULES_MODIFY',

    VIEW_CONFIG_SCORING : 'AUTHORIZATION_CONFIGURATOR_SCORING_VIEW',

    MODIFY_CONFIG_SCORING : 'AUTHORIZATION_CONFIGURATOR_SCORING_MODIFY',

    VIEW_CONFIG_SYSTEM_ADMIN_USERS : 'AUTHORIZATION_CONFIGURATOR_SYSTEM_ADMIN_USERS_VIEW',

    MODIFY_CONFIG_SYSTEM_ADMIN_USERS : 'AUTHORIZATION_CONFIGURATOR_SYSTEM_ADMIN_USERS_MODIFY',

    VIEW_CONFIG_AGENCY_ADMIN_USERS : 'AUTHORIZATION_CONFIGURATOR_AGENCY_ADMIN_USERS_VIEW',

    MODIFY_CONFIG_AGENCY_ADMIN_USERS : 'AUTHORIZATION_CONFIGURATOR_AGENCY_ADMIN_USERS_MODIFY',

    VIEW_CONFIG_CARRIER_ADMIN_USERS : 'AUTHORIZATION_CONFIGURATOR_CARRIER_ADMIN_USERS_VIEW',

    MODIFY_CONFIG_CARRIER_ADMIN_USERS : 'AUTHORIZATION_CONFIGURATOR_CARRIER_ADMIN_USERS_MODIFY',

    VIEW_CONFIG_UNDERWRITERS : 'AUTHORIZATION_CONFIGURATOR_UNDERWRITERS_VIEW',

    VIEW_CONFIG_UNDERWRITER_LETTER_OF_AUTHORITY : 'AUTHORIZATION_CONFIGURATOR_UNDERWRITER_LETTER_OF_AUTHORITY_VIEW',

    MODIFY_CONFIG_UNDERWRITERS : 'AUTHORIZATION_CONFIGURATOR_UNDERWRITERS_MODIFY',

    MODIFY_CONFIG_UNDERWRITER_LETTER_OF_AUTHORITY : 'AUTHORIZATION_CONFIGURATOR_UNDERWRITER_LETTER_OF_AUTHORITY_MODIFY',

    VIEW_CONFIG_PRODUCERS : 'AUTHORIZATION_CONFIGURATOR_PRODUCERS_VIEW',

    MODIFY_CONFIG_PRODUCERS : 'AUTHORIZATION_CONFIGURATOR_PRODUCERS_MODIFY',

    VIEW_CONFIG_SERVICE_USERS : 'AUTHORIZATION_CONFIGURATOR_SERVICE_USERS_VIEW',

    MODIFY_CONFIG_SERVICE_USERS : 'AUTHORIZATION_CONFIGURATOR_SERVICE_USERS_MODIFY',

    VIEW_CONFIG_SYSTEM_ROLES : 'AUTHORIZATION_CONFIGURATOR_SYSTEM_ROLES_VIEW',

    MODIFY_CONFIG_SYSTEM_ROLES : 'AUTHORIZATION_CONFIGURATOR_SYSTEM_ROLES_MODIFY',

    VIEW_CONFIG_CARRIER_ROLES : 'AUTHORIZATION_CONFIGURATOR_CARRIER_ROLES_VIEW',

    MODIFY_CONFIG_CARRIER_ROLES : 'AUTHORIZATION_CONFIGURATOR_CARRIER_ROLES_MODIFY',

    VIEW_CONFIG_PRODUCER_ROLES : 'AUTHORIZATION_CONFIGURATOR_PRODUCER_ROLES_VIEW',

    MODIFY_CONFIG_PRODUCER_ROLES : 'AUTHORIZATION_CONFIGURATOR_PRODUCER_ROLES_MODIFY',

    VIEW_CONFIG_SERVICE_ROLES : 'AUTHORIZATION_CONFIGURATOR_SERVICE_ROLES_VIEW',

    MODIFY_CONFIG_SERVICE_ROLES : 'AUTHORIZATION_CONFIGURATOR_SERVICE_ROLES_MODIFY',

    VIEW_CONFIG_CARRIERS : 'AUTHORIZATION_CONFIGURATOR_CARRIER_ORG_VIEW',

    VIEW_CONFIG_CARRIERS_LETTER_OF_AUTHORITY : 'AUTHORIZATION_CONFIGURATOR_CARRIER_ORG_LETTER_OF_AUTHORITY_VIEW',

    MODIFY_CONFIG_CARRIERS : 'AUTHORIZATION_CONFIGURATOR_CARRIER_ORG_MODIFY',

    MODIFY_CONFIG_CARRIERS_LETTER_OF_AUTHORITY : 'AUTHORIZATION_CONFIGURATOR_CARRIER_ORG_LETTER_OF_AUTHORITY_MODIFY',

    VIEW_CONFIG_AGENCY_BROKERAGE : 'AUTHORIZATION_CONFIGURATOR_AGENCY_ORG_VIEW',

    VIEW_CONFIG_AGENCY_BROKERAGE_LETTER_OF_AUTHORITY : 'AUTHORIZATION_CONFIGURATOR_AGENCY_BROKERAGE_ORG_LETTER_OF_AUTHORITY_VIEW',

    MODIFY_CONFIG_AGENCY_BROKERAGE : 'AUTHORIZATION_CONFIGURATOR_AGENCY_ORG_MODIFY',

    MODIFY_CONFIG_AGENCY_BROKERAGE_LETTER_OF_AUTHORITY : 'AUTHORIZATION_CONFIGURATOR_AGENCY_BROKERAGE_ORG_LETTER_OF_AUTHORITY_MODIFY',

    VIEW_CONFIG_EMAIL : 'AUTHORIZATION_CONFIGURATOR_EMAIL_VIEW',

    MODIFY_CONFIG_EMAIL : 'AUTHORIZATION_CONFIGURATOR_EMAIL_MODIFY',

    MANAGE_POPUP_NOTIFICATIONS : 'AUTHORIZATION_CONFIGURATOR_MANAGE_POPUP_NOTIFICATIONS',

    VIEW_POPUP_NOTIFICATIONS : 'AUTHORIZATION_CONFIGURATOR_VIEW_POPUP_NOTIFICATIONS',

    MODIFY_CONFIG_BACKUP_RESTORE : 'AUTHORIZATION_CONFIGURATOR_BACKUP_RESTORE_MODIFY',

    VIEW_CONFIG_DETAILED_HISTORY : 'AUTHORIZATION_CONFIGURATOR_DETAILED_HISTORY_VIEW',

    VIEW_CONFIG_STATE_RATES : 'AUTHORIZATION_CONFIGURATOR_STATE_RATES_VIEW',

    MODIFY_CONFIG_STATE_RATES : 'AUTHORIZATION_CONFIGURATOR_STATE_RATES_MODIFY',

    VIEW_CONFIG_MGA_CARRIERS : 'AUTHORIZATION_CONFIGURATOR_MGA_CARRIER_ORG_VIEW',

    VIEW_CONFIG_MGA_CARRIERS_LETTER_OF_AUTHORITY : 'AUTHORIZATION_CONFIGURATOR_MGA_CARRIER_ORG_LETTER_OF_AUTHORITY_VIEW',

    MODIFY_CONFIG_MGA_CARRIERS : 'AUTHORIZATION_CONFIGURATOR_MGA_CARRIER_ORG_MODIFY',

    MODIFY_CONFIG_MGA_CARRIERS_LETTER_OF_AUTHORITY : 'AUTHORIZATION_CONFIGURATOR_MGA_CARRIER_ORG_LETTER_OF_AUTHORITY_MODIFY',

    VIEW_CONFIG_MGA_UNDERWRITERS : 'AUTHORIZATION_CONFIGURATOR_MGA_UNDERWRITERS_VIEW',

    VIEW_CONFIG_MGA_UNDERWRITER_LETTER_OF_AUTHORITY : 'AUTHORIZATION_CONFIGURATOR_MGA_UNDERWRITER_LETTER_OF_AUTHORITY_VIEW',

    MODIFY_CONFIG_MGA_UNDERWRITERS : 'AUTHORIZATION_CONFIGURATOR_MGA_UNDERWRITERS_MODIFY',

    MODIFY_CONFIG_MGA_UNDERWRITER_LETTER_OF_AUTHORITY : 'AUTHORIZATION_CONFIGURATOR_MGA_UNDERWRITER_LETTER_OF_AUTHORITY_MODIFY',

    VIEW_CONFIG_MGA_AGENCY_BROKERAGE : 'AUTHORIZATION_CONFIGURATOR_MGA_AGENCY_BROKERAGE_ORG_VIEW',

    VIEW_CONFIG_MGA_AGENCY_BROKERAGE_LETTER_OF_AUTHORITY : 'AUTHORIZATION_CONFIGURATOR_MGA_AGENCY_BROKERAGE_ORG_LETTER_OF_AUTHORITY_VIEW',

    MODIFY_CONFIG_MGA_AGENCY_BROKERAGE : 'AUTHORIZATION_CONFIGURATOR_MGA_AGENCY_BROKERAGE_ORG_MODIFY',

    MODIFY_CONFIG_MGA_AGENCY_BROKERAGE_LETTER_OF_AUTHORITY : 'AUTHORIZATION_CONFIGURATOR_MGA_AGENCY_BROKERAGE_ORG_LETTER_OF_AUTHORITY_MODIFY',

    VIEW_MODIFY_CONFIG_DEFAULT_PRODUCERS : 'AUTHORIZATION_CONFIGURATOR_VIEW_MANAGE_DEFAULT_PRODUCERS',

    VIEW_CONFIG_USER_LOGIN_TYPE : 'AUTHORIZATION_VIEW_USER_LOGIN_TYPE',

    MODIFY_CONFIG_USER_LOGIN_TYPE : 'AUTHORIZATION_MANAGE_USER_LOGIN_TYPE',

    MODIFY_CONFIG_USER_GROUPS : 'AUTHORIZATION_CONFIGURATOR_MANAGE_USER_GROUP',

    VIEW_CONFIG_COLUMNS : 'AUTHORIZATION_VIEW_BA_STUDIO_COLUMNS',

    MODIFY_CONFIG_COLUMNS : 'AUTHORIZATION_MANAGE_BA_STUDIO_COLUMNS',

    SUBMISSION_VIEW_AUDIT_TRAIL : 'AUTHORIZATION_SUBMISSION_VIEW_AUDIT_TRAIL',

    LOGIN_CONFIGURATOR : 'AUTHORIZATION_CONFIGURATOR',

    LOGIN_AGENT_WORKSPACE : 'AUTHORIZATION_AGENT_WORKSPACE',

    LOGIN_UNDERWRITER_WORKSTATION : 'AUTHORIZATION_UNDERWRITER_WORKSTATION',

    LOGIN_OPERATOR_CONSOLE : 'AUTHORIZATION_OPERATOR_CONSOLE',

    LOGIN_APPREADER : 'AUTHORIZATION_APPREADER',

    AUTHORIZATION_VIEW_SUBMISSION_APPLICATION : 'AUTHORIZATION_VIEW_SUBMISSION_APPLICATION',

    AUTHORIZATION_VIEW_SUBMISSION_REPORTS : 'AUTHORIZATION_VIEW_SUBMISSION_REPORTS',

    AUTHORIZATION_VIEW_SUBMISSION_PROPOSALS : 'AUTHORIZATION_VIEW_SUBMISSION_PROPOSALS',

    AUTHORIZATION_VIEW_SUBMISSION_WORKSHEETS : 'AUTHORIZATION_VIEW_SUBMISSION_WORKSHEETS',

    AUTHORIZATION_VIEW_SUBMISSION_PREDICTIVE_ANALYTICS : 'AUTHORIZATION_VIEW_SUBMISSION_PREDICTIVE_ANALYTICS',

    AUTHORIZATION_VIEW_SUBMISSION_POLICY : 'AUTHORIZATION_VIEW_SUBMISSION_POLICY',

    MANAGE_FORMS : 'AUTHORIZATION_MANAGE_FORMS',

    AUTHORIZATION_ADD_MODIFY_NOTES : 'AUTHORIZATION_ADD_MODIFY_NOTES',

    AUTHORIZATION_DELETE_NOTES : 'AUTHORIZATION_DELETE_NOTES',

    AUTHORIZATION_SHARE_UNSHARE_NOTES : 'AUTHORIZATION_SHARE_UNSHARE_NOTES',

    AUTHORIZATION_MODIFY_OTHER_USERS_NOTE_OPTIONS : 'AUTHORIZATION_MODIFY_OTHER_USERS_NOTE_OPTIONS',

    MANAGE_RULES : 'AUTHORIZATION_MANAGE_RULES',

    MANAGE_SYSTEM_CONFIGURATOR : 'AUTHORIZATION_MANAGE_SYSTEM_CONFIGURATOR',

    MANAGE_GENERAL_PREFERENCES : 'AUTHORIZATION_MANAGE_GENERAL_PREFERENCES',

    MANAGE_BA_STUDIO_PREFERENCES : 'AUTHORIZATION_MANAGE_BA_STUDIO_PREFERENCES',

    MANAGE_SECURTIY_MANAGEMENT : 'AUTHORIZATION_MANAGE_SECURTIY_MANAGEMENT',

    MANAGE_SYSTEM_URLS : 'AUTHORIZATION_MANAGE_SYSTEM_URLS',

    MANAGE_FILE_MANAGEMENT : 'AUTHORIZATION_MANAGE_FILE_MANAGEMENT',

    MANAGE_SETTING_MANAGER : 'AUTHORIZATION_MANAGE_SETTING_MANAGER',

    MANAGE_MESSAGE_CENTER : 'AUTHORIZATION_MANAGE_MESSAGE_CENTER',

    MANAGE_USER_CENTER : 'AUTHORIZATION_MANAGE_USER_CENTER',

    VIEW_GENERAL_PREFERENCES : 'AUTHORIZATION_VIEW_GENERAL_PREFERENCES',

    VIEW_BA_STUDIO_PREFERENCES : 'AUTHORIZATION_VIEW_BA_STUDIO_PREFERENCES',

    VIEW_SECURTIY_MANAGEMENT : 'AUTHORIZATION_VIEW_SECURTIY_MANAGEMENT',

    VIEW_SYSTEM_URLS : 'AUTHORIZATION_VIEW_SYSTEM_URLS',

    VIEW_FILE_MANAGEMENT : 'AUTHORIZATION_VIEW_FILE_MANAGEMENT',

    VIEW_SETTING_MANAGER : 'AUTHORIZATION_VIEW_SETTING_MANAGER',

    VIEW_MESSAGE_CENTER : 'AUTHORIZATION_VIEW_MESSAGE_CENTER',

    VIEW_USER_CENTER : 'AUTHORIZATION_VIEW_USER_CENTER',

    VIEW_DETAIL_HISTORY : 'AUTHORIZATION_VIEW_DETAIL_HISTORY',

    VIEW_WELCOME_LOGIN_MESSAGE : 'AUTHORIZATION_VIEW_WELCOME_LOGIN_MESSAGE',

    MANAGE_WELCOME_LOGIN_MESSAGE : 'AUTHORIZATION_MANAGE_WELCOME_LOGIN_MESSAGE',

    MANAGE_BACKUP_RESTORE_CENTER : 'AUTHORIZATION_MANAGE_BACKUP_RESTORE_CENTER',

    MANAGE_CUSTOM_FILES_AND_ICONS : 'AUTHORIZATION_MANAGE_CUSTOM_FILES_AND_ICONS',

    VIEW_CUSTOM_FILES_AND_ICONS : 'AUTHORIZATION_VIEW_CUSTOM_FILES_AND_ICONS',

    AUTHORIZATION_GENERATE_DATA_DICTIONARY : 'AUTHORIZATION_GENERATE_DATA_DICTIONARY',

    POLICY_SUBMIT_ISSUANCE : 'AUTHORIZATION_SUBMIT_ISSUANCE',

    POLICY_MARK_ISSUED : 'AUTHORIZATION_MARK_ISSUED',

    POLICY_REVERSE_ISSUANCE : 'AUTHORIZATION_REVERT_ISSUANCE',

    POLICY_CANCEL : 'AUTHORIZATION_POLICY_CANCEL',

    AUTHORIZATION_POLICY_REVERT_TO_CANCELLATION_PENDING : 'AUTHORIZATION_POLICY_REVERT_TO_CANCELLATION_PENDING',

    POLICY_SUBMIT_CANCELLATION : 'AUTHORIZATION_POLICY_SUBMIT_CANCELLATION',

    POLICY_REWRITE_AFTER_CANCELLATION : 'AUTHORIZATION_POLICY_REWRITE_AFTER_CANCELLATION',

    POLICY_REQUEST_CANCELLATION : 'AUTHORIZATION_POLICY_REQUEST_CANCELLATION',

    POLICY_RETRACT_CANCELLATION_REQUEST : 'AUTHORIZATION_POLICY_RETRACT_CANCELLATION_REQUEST',

    POLICY_REINSTATE : 'AUTHORIZATION_POLICY_REINSTATE',

    POLICY_RESCIND_CANCELLATION : 'AUTHORIZATION_RESCIND_CANCELLATION',

    POLICY_VIEW_REWRITE : 'AUTHORIZATION_POLICY_VIEW_REWRITE',

    PREQUALIFY_SUBMISSION : 'AUTHORIZATION_PREQUALIFY_SUBMISSION',

    QUOTE_INITIATE_NEW_PROPOSAL_AND_GET_RATE : 'AUTHORIZATION_QUOTE_INITIATE_NEW_PROPOSAL_AND_GET_RATE',

    QUOTE_GENERATE_MODIFY_PROPOSAL : 'AUTHORIZATION_QUOTE_GENERATE_MODIFY_PROPOSAL',

    QUOTE_SEND_TO_AGENT : 'AUTHORIZATION_QUOTE_SEND_TO_AGENT',

    QUOTE_WITHDRAW_QUOTE : 'AUTHORIZATION_QUOTE_WITHDRAW_QUOTE',

    QUOTE_REMOVE_MANDATORY_POLICY_FORMS : 'AUTHORIZATION_QUOTE_REMOVE_MANDATORY_POLICY_FORMS',

    QUOTE_GENERATE_RATING_ATTACHMENT : 'AUTHORIZATION_QUOTE_GENERATE_RATING_ATTACHMENT',

    CONFIRM_BINDING : 'AUTHORIZATION_CONFIRM_BINDING',

    UNBIND_COVERAGE : 'AUTHORIZATION_UNBIND_COVERAGE',

    REQUEST_BINDING : 'AUTHORIZATION_REQUEST_BINDING',

    DECLINE_BINDING : 'AUTHORIZATION_DECLINE_BINDING',

    WITHDRAW_BIND_REQUEST : 'AUTHORIZATION_WITHDRAW_BIND_REQUEST',

    REFERRAL_CLEAR_AND_DECLINE_REFERRAL : 'AUTHORIZATION_REFERRAL_CLEAR_AND_DECLINE',

    REFERRAL_RETRACT_AND_REFER_SUBMISSION : 'AUTHORIZATION_RETRACT_REFERRAL_AND_REFER_SUBMISSION',

    REPORTS_OBTAIN_INTERNAL_AND_EXTERNAL : 'AUTHORIZATION_REPORTS_OBTAIN_INTERNAL_AND_EXTERNAL',

    REPORTS_CREATE : 'AUTHORIZATION_REPORTS_CREATE',

    REPORTS_DELETE : 'AUTHORIZATION_REPORTS_DELETE',

    ASSIGN_ACCOUNT : 'AUTHORIZATION_SUBMISSION_ASSIGN_ACCOUNT',

    VIEW_ACCOUNT_OVERVIEW : 'AUTHORIZATION_ACCOUNT_VIEW_ACCOUNT_OVERVIEW',

    MODIFY_ACCOUNT_OVERVIEW : 'AUTHORIZATION_ACCOUNT_MODIFY_ACCOUNT_OVERVIEW',

    SUBMISSION_CREATE : 'AUTHORIZATION_SUBMISSION_CREATE',

    SUBMISSION_DELETE_DRAFT : 'AUTHORIZATION_SUBMISSION_DELETE_DRAFT',

    SUBMISSION_SUBMIT_FULL_OR_TO_RESERVE_MARKET : 'AUTHORIZATION_SUBMISSION_SUBMIT_FULL_OR_TO_RESERVE_MARKET',

    SUBMISSION_DECLINE : 'AUTHORIZATION_SUBMISSION_DECLINE',

    REACTIVATE_SUBMISSION : 'AUTHORIZATION_REACTIVATE_SUBMISSION',

    COPY_SUBMISSION : 'AUTHORIZATION_COPY_SUBMISSION',

    SPLIT_SUBMISSION : 'AUTHORIZATION_SUBMISSION_SPLIT_SUBMISSION',

    SUBMISSION_REJECT : 'AUTHORIZATION_SUBMISSION_REJECT',

    CHANGE_STATUS_TO_LOST : 'AUTHORIZATION_CHANGE_STATUS_TO_LOST',

    SUBMIT_RENEWAL : 'AUTHORIZATION_SUBMIT_RENEWAL',

    MARK_RENEWED : 'AUTHORIZATION_MARK_RENEWED',

    MARK_EXPIRED : 'AUTHORIZATION_MARK_EXPIRED',

    SUBMIT_NON_RENEWAL : 'AUTHORIZATION_SUBMIT_NON_RENEWAL',

    MARK_NON_RENEWED : 'AUTHORIZATION_MARK_NON_RENEWED',

    RETRACT_NON_RENEWAL : 'AUTHORIZATION_RETRACT_NON_RENEWAL',

    SUBMISSION_REVISE : 'AUTHORIZATION_SUBMISSION_REVISE',

    SUBMISSION_ACKNOWLEDGE_CHANGES_BY_AGENT : 'AUTHORIZATION_SUBMISSION_ACKNOWLEDGE_CHANGES_BY_AGENT',

    SUBMISSION_MODIFY_BOUND : 'AUTHORIZATION_SUBMISSION_MODIFY_BOUND',

    SUBMISSION_MODIFY_PRODUCER_DRAFT : 'AUTHORIZATION_SUBMISSION_MODIFY_PRODUCER_DRAFT',

    SUBMISSION_MODIFY_AND_DELETE_CARRIER_DRAFT : 'AUTHORIZATION_SUBMISSION_MODIFY_AND_DELETE_CARRIER_DRAFT',

    SUBMISSION_MODIFY_APPLICATION : 'AUTHORIZATION_SUBMISSION_MODIFY_APPLICATION',

    SUBMISSION_MODIFY_WORKSHEETS : 'AUTHORIZATION_SUBMISSION_MODIFY_WORKSHEETS',

    SUBMISSION_UPDATE_STATUS_REASON : 'AUTHORIZATION_SUBMISSION_UPDATE_STATUS_REASON',

    SUBMISSION_SET_PRODUCTS : 'AUTHORIZATION_SUBMISSION_SET_PRODUCTS',

    SUBMISSION_UPDATE : 'AUTHORIZATION_SUBMISSION_UPDATE',

    SUBMISSION_BULK_ASSIGN_SUBMISSION_PARTICIPANTS : 'AUTHORIZATION_SUBMISSION_BULK_ASSIGN_SUBMISSION_PARTICIPANTS',

    SUBMISSION_TASK_BULK_UPDATE : 'AUTHORIZATION_SUBMISSION_TASK_BULK_UPDATE',

    TASK_ADD_MODIFY : 'AUTHORIZATION_TASK_ADD_MODIFY',

    TASK_DELETE : 'AUTHORIZATION_TASK_DELETE',

    SUBMISSION_ASSIGN : 'AUTHORIZATION_SUBMISSION_ASSIGN',

    PERFORM_CLEARANCE : 'AUTHORIZATION_PERFORM_CLEARANCE',

    CHECK_CLEARANCE : 'AUTHORIZATION_CHECK_CLEARANCE',

    MARK_CLEAR_READY : 'AUTHORIZATION_MARK_READY_TO_UNDERWRITE_OR_REVERT_TO_CLEAR',

    MODIFY_AUTOMATION_STATUS : 'AUTHORIZATION_MODIFY_AUTOMATION_STATUS',

    REEVALUATE_SUBMISSION : 'AUTHORIZATION_REEVALUATE_SUBMISSION',

    ATTACHMENTS_DELETE_NONDELETABLE : 'AUTHORIZATION_ATTACHMENTS_DELETE_NONDELETABLE',

    ENDORSEMENT_CREATE : 'AUTHORIZATION_ENDORSEMENT_CREATE',

    ENDORSEMENT_SUBMIT : 'AUTHORIZATION_ENDORSEMENT_SUBMIT',

    ENDORSEMENT_REVERT_TO_SUBMITTED : 'AUTHORIZATION_ENDORSEMENT_REVERT_TO_SUBMITTED',

    ENDORSEMENT_SUBMIT_FOR_ISSUANCE : 'AUTHORIZATION_ENDORSEMENT_SUBMIT_FOR_ISSUANCE',

    ENDORSEMENT_MARK_AS_ISSUED : 'AUTHORIZATION_ENDORSEMENT_MARK_AS_ISSUED',

    ENDORSEMENT_REVERT_TO_PENDING_ISSUANCE : 'AUTHORIZATION_ENDORSEMENT_REVERT_TO_PENDING_ISSUANCE',

    ENDORSEMENT_APPROVE_OR_DECLINE : 'AUTHORIZATION_ENDORSEMENT_APPROVE_OR_DECLINE',

    ENDORSEMENT_REOPEN : 'AUTHORIZATION_ENDORSEMENT_REOPEN',

    ENDORSEMENT_DELETE : 'AUTHORIZATION_ENDORSEMENT_DELETE',

    ENDORSEMENT_MODIFY_APPLICATION : 'AUTHORIZATION_ENDORSEMENT_MODIFY_APPLICATION',

    CROSS_SELL_UP_SELL : 'AUTHORIZATION_CROSS_SELL_UP_SELL',

    LOB_ADD_TO_SUBMISSION : 'AUTHORIZATION_ADD_LOB_TO_SUBMISSION',

    LOB_CHANGE : 'AUTHORIZATION_CHANGE_LOB',

    POST_BINDING_NOTIFICATION : 'AUTHORIZATION_POST_BINDING_NOTIFICATION',

    PREQUOTE_RISK : 'AUTHORIZATION_PREQUOTE_RISK',

    QUOTE_VIEW_APPLICATION_STATE : 'AUTHORIZATION_QUOTE_VIEW_APPLICATION_STATE',

    REINSURANCE_BIND_COVERAGE : 'AUTHORIZATION_REINSURANCE_BIND_COVERAGE',

    REINSURANCE_REQUEST_QUOTE : 'AUTHORIZATION_REINSURANCE_REQUEST_QUOTE',

    RENEWAL_BIND : 'AUTHORIZATION_RENEWAL_BIND',

    RENEWAL_ISSUE_QUOTE : 'AUTHORIZATION_RENEWAL_ISSUE_QUOTE',

    SUBMISSION_UPGRADE : 'AUTHORIZATION_SUBMISSION_UPGRADE',

    SYSTEM_STATE_RESTART_AND_STOP : 'AUTHORIZATION_SYSTEM_STATE_RESTART_AND_STOP',

    SUBMISSION_RESUBMIT : 'AUTHORIZATION_SUBMISSION_RESUBMIT',

    AUTHORIZATION_ADVANCED_FILTER : 'AUTHORIZATION_ADVANCED_FILTER',

    VIEW_PRIVATE_ATTACHMENTS : 'AUTHORIZATION_VIEW_PRIVATE_ATTACHMENTS',

    VIEW_PRIVATE_NOTES : 'AUTHORIZATION_VIEW_PRIVATE_NOTES',

    ACCOUNT_MODIFY_WORKSHEETS : 'AUTHORIZATION_ACCOUNT_MODIFY_WORKSHEETS',

    AUTHORIZATION_ADD_ATTACHMENTS : 'AUTHORIZATION_ADD_ATTACHMENTS',

    AUTHORIZATION_DELETE_ATTACHMENTS : 'AUTHORIZATION_DELETE_ATTACHMENTS',

    AUTHORIZATION_MODIFY_ATTACHMENTS : 'AUTHORIZATION_MODIFY_ATTACHMENTS',

    AUTHORIZATION_SHARE_ATTACHMENTS : 'AUTHORIZATION_SHARE_ATTACHMENTS',

    MANAGE_CONFIG_SECTION_TEMPLATES : 'AUTHORIZATION_CONFIGURATOR_SECTION_TEMPLATES_MANAGE',

    VIEW_CONFIG_SECTION_TEMPLATES : 'AUTHORIZATION_CONFIGURATOR_SECTION_TEMPLATES_VIEW',

    SEND_EMAIL : 'AUTHORIZATION_EMAIL_SEND_EMAIL',

    AUTHORIZATION_EMAIL_DELETE_EMAIL : 'AUTHORIZATION_EMAIL_DELETE_EMAIL',

    AUTHORIZATION_EMAIL_VIEW_PRIVATE_EMAIL : 'AUTHORIZATION_EMAIL_VIEW_PRIVATE_EMAIL',

    AUTHORIZATION_CONFIGURATOR_MANAGE_PRODUCT_TEMPLATES : 'AUTHORIZATION_CONFIGURATOR_MANAGE_PRODUCT_TEMPLATES',

    AUTHORIZATION_CONFIGURATOR_VIEW_PRODUCT_TEMPLATES : 'AUTHORIZATION_CONFIGURATOR_VIEW_PRODUCT_TEMPLATES',

    AUTHORIZATION_CANCEL_POLICY_BEYOND_NOTIFICATION_PERIOD : 'AUTHORIZATION_CANCEL_POLICY_BEYOND_NOTIFICATION_PERIOD',

    AUTHORIZATION_HIDE_SHARED_EMAIL : 'AUTHORIZATION_HIDE_SHARED_EMAIL',

    AUTHORIZATION_OUTLOOK_CREATE_SUBMISSIONS : 'AUTHORIZATION_OUTLOOK_CREATE_SUBMISSIONS',

    AUTHORIZATION_QUOTE_VIEW_UNBOUND_QUOTES : 'AUTHORIZATION_QUOTE_VIEW_UNBOUND_QUOTES',

    AUTHORIZATION_QUOTE_VIEW_RATING_ATTACHMENTS : 'AUTHORIZATION_QUOTE_VIEW_RATING_ATTACHMENTS',

    AUTHORIZATION_QUOTE_VIEW_INPUT_FORMS : 'AUTHORIZATION_QUOTE_VIEW_INPUT_FORMS'

};

angular.module('gw-um-j2js')
    .constant('authorizationConstants', authorizationConstants);